import React from 'react';
import { useParams } from 'next/navigation';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { Variant } from 'shared/types/product';
import { useLocale } from 'frontastic/hooks/useLocale';

interface Props {
  variant: Variant | undefined;
}

const UVPPrice: React.FC<Props> = ({ variant }) => {
  const { locale } = useLocale();
  let uvpPrice = null;
  try {
    uvpPrice = variant?.attributes?.uvp_price ? JSON.parse(variant?.attributes.uvp_price) : null;
  } catch (e) {
    uvpPrice = null;
  }

  if (
    uvpPrice?.centAmount === variant?.price?.centAmount ||
    uvpPrice?.centAmount === variant?.discountedPrice?.centAmount
  ) {
    uvpPrice = null;
  }
  const currencyCode = variant?.attributes?.uvp_price ? uvpPrice?.currencyCode : variant?.price?.currencyCode;

  const fractionDigits = variant?.price?.fractionDigits;

  return <>{CurrencyHelpers.formatForCurrency(uvpPrice?.centAmount, locale, currencyCode, fractionDigits)}</>;
};

export default UVPPrice;
